import React from 'react'
// import './ttl-element.scss'

import { InfoCircleOutlined } from '@ant-design/icons'
import { getClassNames } from '../../../_utils/classnames'
import { Form, Input, Select } from 'antd'

type TtlMetric = 'days' | 'hours' | 'minutes' | 'seconds'

export function calculateRawTtlSecondsFromValue(value: number, metric: TtlMetric): number {
    let computed = value

    switch (metric) {
        case 'minutes':
            computed = computed * 60
            break
        case 'hours':
            computed = computed * 60 * 60
            break
        case 'days':
            computed = computed * 60 * 60 * 24
            break
    }

    return computed
}

export function calculateValueFromRawTtlSeconds(value: number, metric: TtlMetric): number {
    let computed = value

    switch (metric) {
        case 'minutes':
            computed = computed / 60
            break
        case 'hours':
            computed = computed / 60 / 60
            break
        case 'days':
            computed = computed / 24 / 60 / 60
            break
    }

    return computed
}

interface ITtlDisplayElement {
    label?: string
    entity: {
        defaultNotificationTtlSeconds: number
        displayMeta?: {
            default_notification_ttl_metric?: string
        }
    }
}

export class TtlDisplayElement extends React.PureComponent<ITtlDisplayElement, any> {
    public render() {
        const rawTtlSeconds = this.props.entity.defaultNotificationTtlSeconds ?? null
        const ttlMetric = this.props.entity.displayMeta?.default_notification_ttl_metric ?? 'days'
        const ttlValue = calculateValueFromRawTtlSeconds(rawTtlSeconds, ttlMetric as TtlMetric)

        return (
            <div className={getClassNames('form-layout-row')}>
                <div className={getClassNames('form-layout-row-label')}>{this.props.label || 'Default Lifespan'}</div>
                <div className={getClassNames('form-layout-row-value')}>
                    {rawTtlSeconds != null ? `${ttlValue} ${ttlMetric.replace(/s$/, '(s)')}` : 'No default'}
                </div>
                <div className={getClassNames('form-layout-row-sub')}>
                    <InfoCircleOutlined />
                    <span>System default is 7 days.</span>
                </div>
            </div>
        )
    }
}

interface ITtlEditorElement {
    label?: string
    entity: {
        defaultNotificationTtlSeconds: number
        displayMeta?: {
            default_notification_ttl_metric?: string
        }
    }
}

export const TtlEditorElement: React.FC<ITtlEditorElement> = (props) => {
    const rawDefaultTtlSeconds = props.entity.defaultNotificationTtlSeconds
    const defaultTtlMetric = props.entity.displayMeta?.default_notification_ttl_metric || 'days'
    const defaultTtlValue = calculateValueFromRawTtlSeconds(rawDefaultTtlSeconds, defaultTtlMetric as TtlMetric)

    return (
        <Form.Item className={getClassNames('ttl-editor-element-lifespan')} label={props.label || 'Default Lifespan'}>
            <Form.Item name="ttlValue" initialValue={defaultTtlValue} noStyle>
                <Input
                    autoComplete="off"
                    addonAfter={
                        <Form.Item name="ttlMetric" initialValue={defaultTtlMetric} noStyle>
                            <Select>
                                <Select.Option value="minutes">minute(s)</Select.Option>
                                <Select.Option value="hours">hour(s)</Select.Option>
                                <Select.Option value="days">day(s)</Select.Option>
                            </Select>
                        </Form.Item>
                    }
                />
            </Form.Item>
        </Form.Item>
    )
}
